export default {
  modalTitle: {
    id: 'trade_in_au_modal_title',
    defaultMessage: 'Trade-in',
  },
  startTradeIn: {
    id: 'trade_in_au_start_trade_in',
    defaultMessage: 'Start Trade-in',
  },
  summaryTitle: {
    id: 'trade_in_au_summary_title',
    defaultMessage: 'Just 3 easy steps',
  },
  summaryText: {
    id: 'trade_in_au_summary_text',
    defaultMessage: 'The fast, easy, and free way to cash in on old tech.',
  },
  step1Title: {
    id: 'trade_in_au_step1_title',
    defaultMessage: 'Step 1',
  },
  step1SubTitle: {
    id: 'trade_in_au_step1_subtitle',
    defaultMessage: 'Get an offer',
  },
  step1Text: {
    id: 'trade_in_au_step1_text',
    defaultMessage:
      'See an offer from a professional refurbisher in about 2 minutes.',
  },
  step2Title: {
    id: 'trade_in_au_step2_title',
    defaultMessage: 'Step 2',
  },
  step2SubTitle: {
    id: 'trade_in_au_step2_subtitle',
    defaultMessage: 'Ship your device',
  },
  step2Text: {
    id: 'trade_in_au_step2_text',
    defaultMessage:
      'Transfer your data and ship your device for free within 21 days.',
  },
  step3Title: {
    id: 'trade_in_au_step3_title',
    defaultMessage: 'Step 3',
  },
  step3SubTitle: {
    id: 'trade_in_au_step3_subtitle',
    defaultMessage: 'Get paid',
  },
  step3Text: {
    id: 'trade_in_au_step3_text',
    defaultMessage: 'Receive a direct deposit within 5 business days.',
  },
  spinnerLoadText: {
    id: 'trade_in_au_spinner_load_text',
    defaultMessage: 'Loading ...',
  },
  acceptOffer: {
    id: 'trade_in_au_accept_offer',
    defaultMessage: 'Accept offer',
  },
  inputEmailLabel: {
    id: 'trade_in_au_input_email_label',
    defaultMessage: 'Email*',
  },
  emailRequiredError: {
    id: 'trade_in_au_input_email_required_error',
    defaultMessage: 'Email required',
  },
  emailInvalidError: {
    id: 'trade_in_au_input_email_invalid_error',
    defaultMessage: 'Invalid email format',
  },
  successAcceptOffer: {
    id: 'trade_in_au_input_email_success_accept_offer',
    defaultMessage: 'Check your email to complete your trade-in',
  },
  successAcceptOfferTitle: {
    id: 'trade_in_au_input_email_success_accept_offer_title',
    defaultMessage: 'Your offer has been accepted',
  },
  selectOptionPlaceholder: {
    id: 'trade_in_apac_select_option_placeholder',
    defaultMessage: 'Please select an option',
  },
  applicationInstructionNotice: {
    id: 'trade_in_apac_application_instruction_notice',
    defaultMessage:
      'After applying, we will send you an email with instructions within about 1 hour.',
  },
  quoteValidityNotice: {
    id: 'trade_in_apac_quote_validity_notice',
    defaultMessage:
      'Trade-in quotes are valid for 30 days from application. Please ship your device within the deadline.',
  },
  emailRequestTitle: {
    id: 'trade_in_apac_email_request_title',
    defaultMessage: 'Please enter your email address',
  },
  privacyPolicyNotice: {
    id: 'trade_in_apac_privacy_policy_notice',
    defaultMessage:
      'We will use your email address to contact you about your trade-in. See our {privacyPolicy, html} for details.',
  },
  privacyPolicyLink: {
    id: 'trade_in_apac_privacy_policy_link',
    defaultMessage: 'Privacy Policy',
  },
}
